// extracted by mini-css-extract-plugin
export default {"scrollbar__thumb__vertical":"scrollbar__thumb__vertical--1Ta54","scrollbar__thumb__horizontal":"scrollbar__thumb__horizontal--2ilKB"};
    if(module.hot) {
      // 1747648152012
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  